import { Row, Col, Input } from "antd";
import { useTranslation } from "react-i18next";
import { Integration } from "/app/src/models";
import { integrationService } from "/app/src/services";
import { useCallback, useState } from "react";
import DefaultMapping from "./defaultMapping";
import Summary from "../common/Summary";
import HeroButton from "/app/src/components/HeroUi/Button";
import Box from "/app/src/components/generic/components/box";

/**
 * Component to manually pulling data from an integration
 */
export default function Manual({ integration }: { integration: Integration }) {
  const { t } = useTranslation();
  const [result, setResult] = useState(null);
  const [data, setData] = useState("");

  /**
   * Test the integration
   */
  const handleTest = useCallback(async () => {
    const response = await integrationService.runIntegration(integration.id, {
      filterValues: data,
    });
    setResult(response);
  }, [data, integration.id]);

  /**
   * Handle change for manual export input field
   */
  const handleInputChange = useCallback(
    (e) => {
      setData(e.target.value);
    },
    [setData],
  );

  return (
    <Box>
      <Row gutter={16}>
        <Col span={24}>
          <Input.TextArea
            value={data}
            rows={4}
            onChange={handleInputChange}
            placeholder={t("translation:manual_export_tip")}
            size="large"
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col offset={20} span={4}>
          <HeroButton
            color="primary"
            fullWidth
            onClick={handleTest}
            isDisabled={!data}
          >
            {t("translation:import")}
          </HeroButton>
        </Col>
      </Row>
      <DefaultMapping integration={integration} />
      {result && <Summary result={result} title="Manual Run Summary" />}
    </Box>
  );
}
